import { Component, OnInit, ViewChild } from '@angular/core';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../../service/util.service';
import { HomeService } from '../../home/home.service';
import { PoAutoSettingComponent } from '../../../component/po-auto-setting/po-auto-setting.component';
import { RoleAccess } from '../../../models/role-access.model';
import { UserData } from '../../../providers/user-data';
import { Router } from '@angular/router';
import { MyService } from '../../../service/my.service';

@Component({
  selector: 'app-po-auto-setting',
  templateUrl: './po-auto-setting.page.html',
  styleUrls: ['./po-auto-setting.page.scss'],
})
export class PoAutoSettingPage implements OnInit {

  roleAccess = new RoleAccess();
  userAccess: any[] = [];
  dataPoAuto: any[] = [];
  selectedCounter:any[] = [];
  listCounter : any[] = [];
  counterId :any=0;
  counterName:any='';
  token: any;
  userProfile: UserProfile = new UserProfile();
  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent;
  constructor(
    private storage: Storage,
    private toastCtrl: ToastController,
    private navCtrl : NavController,
    private utilService : UtilService,
    private homeService: HomeService,
    private modalController : ModalController,
    private userData: UserData,
    private router: Router,
    private myService:MyService
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile,access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        window.dispatchEvent(new CustomEvent('user:getmenu'));
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.selectedCounter=[];
          this.getDataCounter();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  getDataCounter() {
    let cashier_id = this.userProfile.cashier_id ? this.userProfile.cashier_id : 0;
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token
      };
      this.homeService.getCounterData(cashier_id,options).subscribe((response) => {
        this.utilService.loadingDismiss();
        let cashierData =  response.results.data;
        const allowedIds = this.userProfile.counter_id_list; // array of allowed IDs
        this.listCounter= response.results.counter_data.filter(counter =>
          allowedIds.includes(counter.id)
        );
        if(cashierData){
          this.counterId = cashierData.counter_id;
          let selectedCounter: any = this.listCounter.find(x => x.id ==  this.counterId);
          if(selectedCounter){
            let idx =this.listCounter.indexOf(selectedCounter);
            this.selectedCounter=(this.listCounter[idx]);
          }
        }
        this.getDataPoAuto();
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  getDataPoAuto() {
    this.dataPoAuto = [];
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "counter_id": this.counterId
      };
      this.homeService.getPoAutoSetting(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.dataPoAuto=  response.results.data;
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  selectCounter(event){
    this.counterId = event.value.id;
    this.dataPoAuto = [];
    this.getDataPoAuto();
  }
   async goToPOSettingComponent(id:any,counterId:any,turnOverStock:any,turnOverOrder:any) {
      const modal = await this.modalController.create({
        component: PoAutoSettingComponent,
        componentProps: {
          id:id,
          counterId: counterId,
          listCounter: this.listCounter,
          turnOverStock:turnOverStock,
          turnOverOrder:turnOverOrder
        },
        backdropDismiss: false
      });
  
      modal.onDidDismiss().then((modelData) => {
        let data = modelData.data;
        if (data !== '') {
          let options = {
            "token": this.token,
            "id":id,
            "turn_over_stock":data.turnOverStock ? this.myService.removeSeparator(data.turnOverStock) : 0,
            "turn_over_order":data.turnOverOrder ? this.myService.removeSeparator(data.turnOverOrder) : 0,
            "counter_id":data.counterId ? data.counterId :  '',
          };
          this.homeService.savePoSetting(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            let result =  response.results.data;
            this.counterId = result.counter_id;
            let selectedCounter: any = this.listCounter.find(x => x.id ==  this.counterId);
            if(selectedCounter){
              let idx =this.listCounter.indexOf(selectedCounter);
              this.selectedCounter=(this.listCounter[idx]);
            }
            this.getDataPoAuto();
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        }
      });
  
      return await modal.present();
    }
}
